export const getDefaultState = () => {
  return {
    partList: []
  };
};

export default {
  ...getDefaultState()
};
